var $languageLoader;
var $languageSelect;
var $languageSubmit;

$(document).ready(function ($) {
  $languageLoader = $('.js-language-loader');
  $languageSelect = $('.js-language-select');
  $languageSubmit = $('.js-language-submit');

  $languageSubmit.on('click', function (event) {
    event.preventDefault();
    saveLanguagePreference($languageSelect.val());
  });
});

function saveLanguagePreference(value) {
  $languageLoader.addClass('is-loading');
  $languageLoader.removeClass('is-success');
  $languageLoader.removeClass('is-error');

  jQuery.ajax({
    url: linku_ajax_url,
    type: 'post',
    data: {
      action: 'save_language_preference',
      language: value,
    },
    dataType: 'json',
    success: function (response) {


      if (!response.success) {
        $languageLoader.removeClass('is-loading');
        $languageLoader.addClass('is-error');
      } else {
        $languageLoader.removeClass('is-loading');
        $languageLoader.addClass('is-success');
      }

    },
    error: function () {
      $languageLoader.removeClass('is-loading');
      $languageLoader.addClass('is-error');
    }
  });
}
